var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('canvas',{staticClass:"canvas-h canvas-w",attrs:{"id":"peninas0a2A"}})])}]

export { render, staticRenderFns }